/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li4_PostInputs */

const tr_iade_iptal_s9_li4_post = /** @type {(inputs: Iade_Iptal_S9_Li4_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adresine gönderilen yazılı bildirim.`)
};

const en_iade_iptal_s9_li4_post = /** @type {(inputs: Iade_Iptal_S9_Li4_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is accepted.`)
};

const de_iade_iptal_s9_li4_post = /** @type {(inputs: Iade_Iptal_S9_Li4_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesendet wird.`)
};

const ru_iade_iptal_s9_li4_post = /** @type {(inputs: Iade_Iptal_S9_Li4_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`принимается.`)
};

/**
* | output |
* | --- |
* | "is accepted." |
*
* @param {Iade_Iptal_S9_Li4_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li4_post = /** @type {((inputs?: Iade_Iptal_S9_Li4_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li4_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li4_post(inputs)
	if (locale === "de") return de_iade_iptal_s9_li4_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li4_post(inputs)
	return tr_iade_iptal_s9_li4_post(inputs)
});